import { PageRef } from 'providers/page-ref';

export type ScheduleTipsPageParams = {};

export const IScheduleTipsPage: PageRef<ScheduleTipsPageParams, void> = {
  pageName: 'ScheduleTipsPage',
} as PageRef<ScheduleTipsPageParams, void>;
